// /join — public ad-entry landing for the "individual" signup journey.
// Sibling of /join/:slug (the group join-link resolver); the bare path is
// the generic "join Lean In Connect" pitch paid ads deep-link to.

import { useEffect } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { EntryJourneyLanding } from '@/components/entry-journeys';
import { useEntryJourneyCopy } from '@/components/entry-journeys/journey-copy';
import { writeEntryJourney } from '@/lib/entry-journey';
import { refSearchParam, storeSignupRef } from '@/lib/signup-ref-cookie';

export const Route = createFileRoute('/_public/join/')({
  // Signed-in visitors already are the conversion — land them on the feed;
  // mid-onboarding visitors re-enter the journey onboarding (see the layout
  // gate exemption in _public.tsx).
  beforeLoad: ({ context }) => {
    if (context.session !== null) {
      if (context.member !== null && context.member.onboardingCompletedAt === null) {
        writeEntryJourney('individual');
        throw redirect({ to: '/onboarding/j/about' });
      }
      throw redirect({ to: '/feed' });
    }
  },
  validateSearch: (search: Record<string, unknown>) => refSearchParam(search),
  component: IndividualEntryPage,
});

function IndividualEntryPage() {
  const { ref } = Route.useSearch();
  // Cookie the campaign ref on arrival (signed-out only — beforeLoad already
  // bounced signed-in visitors) so it survives the signup + OAuth round-trip;
  // /auth/finishing claims it. The URL stays clean from here on.
  useEffect(() => {
    if (ref !== undefined) storeSignupRef(ref);
  }, [ref]);
  return (
    <EntryJourneyLanding
      journey="individual"
      {...useEntryJourneyCopy('individual')}
    />
  );
}
